<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button *ngIf="showClose" type="button" class="close" aria-label="Close" (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" [innerHTML]=body></div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="ok()">{{ btnText }}</button>
</div>